import { render } from "./CongratulationsModal.vue?vue&type=template&id=8b530044"
import script from "./CongratulationsModal.vue?vue&type=script&lang=js"
export * from "./CongratulationsModal.vue?vue&type=script&lang=js"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__